import React, { useState, useEffect, useMemo } from 'react'
import { Pagination, Spin } from "antd"
import SearchField from "../../home/components/filters/SearchField"
import SelectFilterOptions from "../../shared/SelectFilterOptions"
import { getItemsUnpushKitCard } from "../../../services/api/3dApi"
import LazyLoad from 'react-lazyload'
import ItemSide from './item-side/ItemSide'
import Image from './Image'
import CreateBatchList from './CreateBatchList'
import { useLocation } from 'react-router-dom'
import {parseJwt} from '../../../helpers/parseToken'
import {getLocalData} from '../../../services/StorageServices'

const SKU_OPTIONS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'THANK_CARD',
        value: 'THANK_CARD'
    },
    {
        name: 'BRAND_KIT',
        value: 'BRAND_KIT'
    },
]

const ListUnpushKitCardPage = () => {
    const location = useLocation()
    const { type } = location.state || {}
    const roles = parseJwt(getLocalData('accessToken')).roles || []
    const canViewNamespace = roles.some(item => ['fac_admin', 'fac_ffm'].includes(item.name))

    const [filters, setFilters] = useState({
        sku: type ? type : ''
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(20)

    const currentData = useMemo(() => data.slice((page - 1) * limit, page * limit), [limit, data, page])

    const _handlePageChange = (page) => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _handleChangeField = (feild, value) => {
        setFilters((prevFilters) => ({ ...prevFilters, [feild]: value ? value.trim() : '' }))
        setPage(1)
    }

    const getItemColorSystemError = async () => {
        try {
            setLoading(true)
            setError('')

            const payload = {
                ...filters,
                page: 1,
                // limit
            }


            const { data: response } = await getItemsUnpushKitCard(payload)

            const { success, data = [], message, error } = { ...response }

            if (!success) return setError(message || error)

            setData(data)
            setTotal(data.length)

        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getItemColorSystemError()
    }, [filters])

    return (
        <div className='ListUnpushKitCardPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách Brand Kit và Thank Card theo design chưa phân lô</h3>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <div className='BatchesFilters'>
                                <div className='row align-items-starts'>
                                    <div className='col-12 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            defaultValue={filters.sku}
                                            style={{ width: '100%' }}
                                            listOptions={SKU_OPTIONS}
                                            field="sku" label="SKU"
                                            handleChange={_handleChangeField}
                                        />
                                    </div>

                                    {canViewNamespace && <div className='col-12 col-xl-3 mb-3'>
                                        <label className="font-weight-bold d-block">Store</label>
                                        <SearchField
                                            field='namespace'
                                            placeholder='Vui lòng nhập store bạn muốn tìm kiếm'
                                            onChangeInput={_handleChangeField}
                                        />
                                    </div>}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            {/* <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} /> */}
                        </div>

                        <div className='ListUnpushKitCardTable'>
                            <Spin spinning={loading} tip='Đang tải...'>
                                <table className='table table-borderless table-striped'>
                                    <thead className="thead-light">
                                        <tr>
                                            {canViewNamespace && <th className="store">Store</th>}
                                            <th className='design'>Design</th>
                                            <th className='file-print'>File in</th>
                                            <th className="sku">SKU</th>
                                            <th className="quantity">Quantity</th>
                                            <th className="action">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !!currentData && currentData.length > 0 ? (
                                                currentData.map((item, index) => {
                                                    const { namespace = '', design_front = '', preview_image = '', type = '', orders = [], _id } = { ...item }
                                                    return (
                                                        <tr key={index}>
                                                            {canViewNamespace && <td>{namespace}</td>}
                                                            <td className='OrderMockUp'>
                                                                <LazyLoad>
                                                                    <div className='d-flex no-gutters'>
                                                                        <div className='col-6 p-1'>
                                                                            <ItemSide type='update-mock-up' side='front' url={design_front} layout='image' />
                                                                        </div>
                                                                    </div>
                                                                </LazyLoad>
                                                            </td>
                                                            <td><Image previewImage={preview_image} /></td>
                                                            <td>{type}</td>
                                                            <td>{orders.length}</td>
                                                            <td>
                                                                <CreateBatchList orders={orders} />
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                )
                                            ) : (
                                                <tr>
                                                    <td colSpan={6}>Không có dữ liệu!</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </Spin>
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={_handlePageChange}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListUnpushKitCardPage